import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';

import { Campaign3Service } from 'app/views/campaign-3/services/campaign3.service';

import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { BasketService } from '../basket.service';
import { ProductItemComplete } from 'app/views/campaign-3/models/campaign-3.model';

@Component({
  selector: 'app-remove-product-from-basket',
  templateUrl: './remove-product-from-basket.component.html',
  styleUrls: ['./remove-product-from-basket.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class RemoveProductFromBasketComponent implements OnInit {

  @Output() productsListSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() productsListCancel: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() rowSelected = {
    identifierField: 'id',
    arrayValues: []
  };

  @ViewChild('productsListTable')
  productsListTable: Campaign3KontableComponent;

  listProductSelected: Array<any> = [];
  paginationType: number = Campaign3KontableComponent.ServerPagination;

  show = {
    table: false
  };

  @Input() productsListAlreadySelected : ProductItemComplete[];

  constructor(
    private srvCampaign: Campaign3Service,
    private srvBasket: BasketService
  ) {}

  ngOnInit() {
    this.listProductSelected = [];
    this.rowSelected.arrayValues = [];
    this.show.table = true;
  }

  /* ======================================
     SELEZIONE RIGHE
  ====================================== */

  onProductsSelected(product: any) {

    if (!product) {
      return;
    }

    var identifier = this.rowSelected.identifierField;
    var productId = product[identifier];

    var indexInSelected = -1;

    for (let i = 0; i < this.listProductSelected.length; i++) {
      if (this.listProductSelected[i][identifier] === productId) {
        indexInSelected = i;
        break;
      }
    }

    // Deselezione
    if (!product.rowSelected) {

      if (indexInSelected > -1) {
        this.listProductSelected.splice(indexInSelected, 1);
      }

      this.removeFromRowSelected(productId);
    }

    // Selezione
    if (product.rowSelected) {

      if (indexInSelected === -1) {
        this.listProductSelected.push(product);
      }

      this.addToRowSelected(productId);
    }
  }

  private addToRowSelected(productId: any) {

    for (let i = 0; i < this.rowSelected.arrayValues.length; i++) {
      if (this.rowSelected.arrayValues[i] === productId) {
        return;
      }
    }

    this.rowSelected.arrayValues.push(productId);
  }

  private removeFromRowSelected(productId: any) {

    for (let i = 0; i < this.rowSelected.arrayValues.length; i++) {
      if (this.rowSelected.arrayValues[i] === productId) {
        this.rowSelected.arrayValues.splice(i, 1);
        return;
      }
    }
  }

  /* ======================================
     SALVATAGGIO / ANNULLA
  ====================================== */

  onClickAggiungiProducts() {
    if (this.listProductSelected.length === 0) {
      return;
    }

    this.productsListSelected.emit(this.listProductSelected);
  }

  onClickAnnullaProducts() {
    this.productsListCancel.emit(true);
  }

  /* ======================================
     SYNC SELEZIONE SU REFRESH / RENDER
  ====================================== */

  onRefreshTable(refreshed: boolean) {

    if (!refreshed) {
      return;
    }

    if (!this.productsListTable || !this.productsListTable.filteredData) {
      return;
    }

    var identifier = this.rowSelected.identifierField;

    for (let i = 0; i < this.productsListTable.filteredData.length; i++) {

      let row = this.productsListTable.filteredData[i];
      let rowId = row[identifier];

      for (let j = 0; j < this.rowSelected.arrayValues.length; j++) {

        if (this.rowSelected.arrayValues[j] === rowId) {
          row.rowSelected = true;

          if (!this.isAlreadySelected(rowId)) {
            this.listProductSelected.push(row);
          }
        }
      }
    }
  }

  onTableRendered() {
    this.onRefreshTable(true);
  }

  private isAlreadySelected(productId: any): boolean {

    var identifier = this.rowSelected.identifierField;

    for (let i = 0; i < this.listProductSelected.length; i++) {
      if (this.listProductSelected[i][identifier] === productId) {
        return true;
      }
    }

    return false;
  }
}




// WEBPACK FOOTER //
// ./src/app/views/baskets/remove-product-from-basket/remove-product-from-basket.component.ts